// extracted by mini-css-extract-plugin
export var body = "_mi-0";
export var sectionHeader = "_mi-4";
export var shortcutColumns = "_mi-2";
export var shortcutList = "_mi-1";
export var shortcutSection = "_mi-3";